// Collection product cards on search page.
// Uses event delegation so behavior survives AJAX re-renders from facets/sorting.
(function () {
  if (window.__collectionProductCardsBound) return;
  window.__collectionProductCardsBound = true;

  const variantPriorityOrder = [
    'near mint',
    'near mint foil',
    'lightly played',
    'lightly played foil',
    'moderately played',
    'moderately played foil',
    'heavily played',
    'heavily played foil',
    'damaged',
    'damaged foil'
  ];

  function normalizeVariantConditionText(rawText) {
    if (!rawText) return '';
    let text = String(rawText).toLowerCase();

    // Option labels include price; strip anything from the price separator onward.
    text = text.split(' - $')[0];
    text = text.replace(/\s+\-\s+[€£$].*$/i, '');

    text = text
      .replace(/normal\s*-\s*/g, '')
      .replace(/\b(en|us|uk)\b/g, '')
      .replace(/\//g, ' ')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    // Common misspellings in condition text.
    return text
      .replace(/ligtly|ligthly|lightley/g, 'lightly')
      .replace(/moderatly/g, 'moderately')
      .replace(/heavly|hevily/g, 'heavily')
      .replace(/damagd|damged|dmaged/g, 'damaged')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getVariantPriorityKey(rawText) {
    const text = normalizeVariantConditionText(rawText);
    if (!text) return 'other';

    if (text.includes('near mint foil')) return 'near mint foil';
    if (text.includes('near mint')) return 'near mint';
    if (text.includes('lightly played foil')) return 'lightly played foil';
    if (text.includes('lightly played')) return 'lightly played';
    if (text.includes('moderately played foil')) return 'moderately played foil';
    if (text.includes('moderately played')) return 'moderately played';
    if (text.includes('heavily played foil')) return 'heavily played foil';
    if (text.includes('heavily played')) return 'heavily played';
    if (text.includes('damaged foil')) return 'damaged foil';
    if (text.includes('damaged')) return 'damaged';

    return 'other';
  }

  function applyPriorityDefaultSelection(select) {
    if (!select || select.dataset.userSelected === 'true') return;

    const options = Array.from(select.options || []);
    if (options.length <= 1) return;

    let bestIndex = -1;
    let bestRank = Number.MAX_SAFE_INTEGER;

    options.forEach((option, index) => {
      const key = getVariantPriorityKey(option.textContent || '');
      const priorityIndex = variantPriorityOrder.indexOf(key);
      const rank = priorityIndex >= 0 ? priorityIndex : variantPriorityOrder.length + index;
      if (rank < bestRank) {
        bestRank = rank;
        bestIndex = index;
      }
    });

    if (bestIndex >= 0 && select.selectedIndex !== bestIndex) {
      select.selectedIndex = bestIndex;
    }
  }

  function syncCardFromSelect(select) {
    if (!select) return;
    applyPriorityDefaultSelection(select);

    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    const variantId = selectedOption.value;
    const price = selectedOption.dataset.price;
    const money = selectedOption.dataset.money;
    const image = selectedOption.dataset.image;
    const inventory = parseInt(selectedOption.dataset.inventory || '0', 10);
    const isAvailable = selectedOption.dataset.available === 'true';
    const card = select.closest('.collection-product-card');
    if (!card) return;

    const priceElement = card.querySelector('.collection-product-price');
    if (priceElement && price) {
      if (money) {
        priceElement.textContent = money;
      } else {
        const activeCurrency = window?.Shopify?.currency?.active || 'USD';
        priceElement.textContent = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: activeCurrency,
          minimumFractionDigits: 2
        }).format(price / 100);
      }
      priceElement.dataset.price = price;
    }

    const productImage = card.querySelector('.collection-product-image');
    if (productImage && image) {
      productImage.src = image;
    }

    const stockElement = card.querySelector('[data-inventory-count]');
    if (stockElement) {
      if (isAvailable && inventory > 0) {
        stockElement.textContent = `${inventory} in stock`;
        stockElement.style.display = '';
      } else {
        stockElement.textContent = '';
        stockElement.style.display = 'none';
      }
    }

    const addToCartBtn = card.querySelector('.collection-add-to-cart-btn');
    if (addToCartBtn) {
      const defaultText = addToCartBtn.dataset.defaultText || 'Add to Cart';
      addToCartBtn.dataset.variantId = variantId;
      addToCartBtn.disabled = !isAvailable;
      addToCartBtn.textContent = isAvailable ? defaultText : 'Sold Out';
    }
  }

  function syncAllVisibleCards() {
    document.querySelectorAll('.collection-variant-select').forEach(syncCardFromSelect);
  }

  async function handleAddToCart(button) {
    if (!button || button.disabled) return;
    const variantId = button.dataset.variantId;
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    button.classList.add('loading');
    button.disabled = true;

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const canRenderDrawerFromResponse =
        cartDrawer &&
        typeof cartDrawer.getSectionsToRender === 'function' &&
        typeof cartDrawer.renderContents === 'function';
      let data;

      if (canRenderDrawerFromResponse && typeof routes !== 'undefined' && routes.cart_add_url) {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map((section) => section.id).join(',')
        );
        formData.append('sections_url', window.location.pathname);

        const response = await fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: formData
        });
        data = await response.json();
      } else {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
        data = await response.json();
      }

      if (data.status && data.status === 422) {
        alert(data.description || 'Unable to add item to cart');
      } else {
        button.textContent = 'Added!';
        const defaultText = button.dataset.defaultText || 'Add to Cart';
        setTimeout(() => {
          button.textContent = defaultText;
        }, 2000);

        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'collection-product-card', productVariantId: variantId });
        }

        if (typeof window.updateStickyCart === 'function') {
          window.updateStickyCart();
        }

        if (canRenderDrawerFromResponse && data.sections) {
          cartDrawer.renderContents(data);
        } else if (cartDrawer) {
          setTimeout(() => {
            cartDrawer.open();
          }, 100);
        }
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error adding item to cart. Please try again.');
    } finally {
      button.classList.remove('loading');
      const card = button.closest('.collection-product-card');
      const select = card ? card.querySelector('.collection-variant-select') : null;
      if (select) {
        syncCardFromSelect(select);
      } else if (!button.textContent.includes('Sold Out')) {
        button.disabled = false;
      }
    }
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.collection-variant-select');
    if (!select) return;
    select.dataset.userSelected = 'true';
    syncCardFromSelect(select);
  });

  document.addEventListener('click', (event) => {
    const variantSelector = event.target.closest('.collection-variant-selector');
    if (variantSelector) {
      event.stopPropagation();
    }

    const button = event.target.closest('.collection-add-to-cart-btn');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    handleAddToCart(button);
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncAllVisibleCards();
  });

  // Facets re-render #ProductGridContainer via AJAX; keep cards in sync after each grid swap.
  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && 'MutationObserver' in window) {
    let syncQueued = false;
    const observer = new MutationObserver(() => {
      if (syncQueued) return;
      syncQueued = true;
      requestAnimationFrame(() => {
        syncAllVisibleCards();
        syncQueued = false;
      });
    });
    // Observe only direct children to avoid feedback loops from text updates within cards.
    observer.observe(gridContainer, { childList: true });
  }
})();
